export const REGISTER_STATUS = {
    BasicInfoSubmitted: 'BASIC_INFO_SUBMITTED',
    PaymentSubmitted: 'PAYMENT_SUBMITTED',
    EmailVerifyWaiting: 'EMAIL_VERIFY_WAITING',
    Completed: 'COMPLETED'
};
